<template>
  <v-dialog v-model="show" max-width="600" overlay-color="darktext" overlay-opacity="0.6" @click:outside="closeDialog()">
    <v-card v-if="page == 'create-invitation'" class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        {{ cdText }}
      </v-card-text>
      <v-card-text>
        <v-autocomplete v-model="select" :menu-props="{
          closeOnContentClick: true,
          rounded: 'xxl',
          zIndex: '9999 !important',
        }" filled rounded deletable-chips clearable solo no-filter :search-input.sync="searchKeyword"
          :items="entries" item-text="title" item-value="title" :placeholder="$t('search')" append-icon="mdi-magnify"
          background-color="#fff" data-testid="search-dashboard" class="expanding-search">
          <template v-slot:selection="" />
          <template v-slot:item="data" data-testid="suggested-item">
            <template v-if="(typeof data.item) !== 'object'">
              <v-list-item-content v-text="data.item" />
            </template>
            <template v-else>
              <v-row no-gutters @click="selectItem(data.item)" align="center">
                <v-col cols="2">
                  <v-img
                    :src="(data.item.attributes.image) ? data.item.attributes.image : require('../assets/cover-activity.jpg')"
                    class="ma-0 mx-2 rounded-lg" :class="data.item.type == 'activities' ? 'activity' : 'hub'" width="50" height="40"
                   />
                </v-col>
                <v-col cols="10">
                  <v-list-item-content>
                    <v-list-item-title class="text-no-wrap text-truncate px-2" style="width:280px">
                      <v-chip v-if="data.item.type == 'hubs'" small color="accent">
                        <span class="text-uppercase">{{ $t('hub') }}</span>
                      </v-chip> {{ data.item.attributes.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-text>
        <v-row v-for="item in selectedItems" :key="item.id" align="center" class="pa-0 elevation-2 rounded-xxl mb-4"
          no-gutters>
          <v-col cols="2">
              <v-responsive>
                <v-img
                  style="
                    border: 1px solid var(--v-greylightBorder-base, 0.7);
                  "
                  class="rounded-tl-xl rounded-bl-xl"
                  :src="
                    item.attributes.image
                      ? item.attributes.image
                      : require('../assets/cover-activity.jpg')
                  "
                  height="54px"
                />
              </v-responsive>
          </v-col>
          <v-col cols="8">
            <v-list-item-content>
              <v-tooltip
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-list-item-title v-on="on" class="text-no-wrap text-truncate px-2" style="width:280px">
                    <v-chip v-if="item.type == 'hubs'" small color="accent">
                      <span class="text-uppercase">{{ $t('hub') }}</span>
                    </v-chip>
                    {{ item.attributes.title }}
                  </v-list-item-title>
                </template>
                <span>{{ item.attributes.title }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-col>
          <v-col cols="2" md="1" offset-md="1" align="center">
            <v-icon medium @click="removeSelectedItem(item)">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          color="accent"
          min-width="100"
          elevation="0"
          class="rounded-xxl text-none px-4 white--text"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else class="pa-5">
      <v-card-title>
        {{ cdTitle }}
        <v-spacer />
        <v-icon
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          class="rounded-xxl text-none mt-n8 mr-n4"
          style="z-index:1;"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text>
        {{ cdText }}
      </v-card-text>
      <v-card-text>
        <v-row v-for="item in selectedItems" :key="item.id" align="center" class="pa-0 elevation-2 rounded-xxl mb-4"
          no-gutters data-testid="items-list">
          <v-col cols="12" class="px-3">
            <v-list-item-content>
              <v-tooltip
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-list-item-title v-on="on" class="text-no-wrap text-truncate px-2" style="width:280px">
                    <v-chip v-if="item.type == 'hubs'" small color="accent">
                      <span class="text-uppercase">{{ $t('hub') }}</span>
                    </v-chip>
                    {{ item.title }}
                  </v-list-item-title>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import { searchActivitiesIsBooster } from '../api/activityApi'
import { searchHubsIsBooster } from '../api/hubApi'
import _ from 'lodash'

export default {
  mixins: [repeatedMethodsMixin],
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    contentConfirmed: {
      type: Array,
      default: () => []
    },
    page: {
      type: String,
      default: 'create-invitation'
    },
  },
  data: function () {
    return {
      select: null,
      searchKeyword: null,
      entries: [],
      spaceId: window.$cookies.get("space_id"),
      selectedItems: []
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.loadingCancel = true
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    searchKeyword(val) {
      if (val == null || val == '') {
        this.entries = []
        return
      }
      let searchkey = val.trim()
      if (searchkey.length < 2) return
      this.searchActivitiesAndHubs(searchkey)
    }
  },
  async created() {
    this.selectedItems = JSON.parse(JSON.stringify(this.contentConfirmed))
  },
  methods: {

    selectItem(item) {
      const indexOfObject = this.selectedItems.findIndex(object => {
        return object.id === item.id;
      });
      //if not found
      if (indexOfObject == -1) {
        this.selectedItems.push(item)
      }

      this.searchKeyword = null
    },
    searchActivitiesAndHubs:_.debounce(async function(keyword) {
      var searchActivities = []
      var searchHubs = []
      if (keyword && keyword.trim().length >= 2) {
        try {
          const response = await searchActivitiesIsBooster(this.spaceId, keyword)
          if (response) {
            if (response.status == 200) {
              searchActivities = response.data.data
            }
          }
        } catch (e) {
          if (e.response) {
            this.error = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
            this.alertValue = true
          }
        }
        if (this.productPlan.attributes && this.productPlan.attributes.name != 'Free') {
          try {
            const response = await searchHubsIsBooster(this.spaceId, keyword)
            if (response) {
              if (response.status == 200) {
                searchHubs = response.data.data
              }
            }
          } catch (e) {
            if (e.response) {
              this.error = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
              this.alertValue = true
            }
          }
        }

        Array.prototype.push.apply(searchActivities, searchHubs)
        searchActivities.sort(function (a, b) { return (a.sort_term > b.sort_term) ? 1 : ((b.sort_term > a.sort_term) ? -1 : 0) })
        this.entries = searchActivities
      }
    }, 500),
    closeDialog() {
      this.loading = true
      this.$emit('input', false);
    },
    removeSelectedItem(item) {
      const indexOfObject = this.selectedItems.findIndex(object => {
        return object.id === item.id;
      });
      //if found
      if (indexOfObject != -1) {
        this.selectedItems.splice(indexOfObject, 1)
      }
    },
    submitDialogBtn(){
      this.$emit('selectedItems', this.selectedItems)
    }
  },

}

</script>